import { ITheme, theme } from "../../../utils/theme";

export const MainWrapper = {
  border: (theme: ITheme) => `solid 4px ${theme.palette.green[500]}`,
}

export const linesSlipTableStyle = {
  borderRightWidth: 1,
  '& .MuiTableRow-root > .MuiTableCell-root': {
    borderRight: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  },
  '& .MuiTableRow-root > .MuiTableCell-root:last-child': {
    borderRight: 'none',
  },
}

export const TableRowStyle = {
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.blue[100],
  },
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.common.white,
  },
}

export const PopupContainerStyle = {
  fontSize: "0.875rem",
  fontWeight: "bold",
  background: (theme: ITheme) => theme.palette.grey["A50"],
  p: 1,
  '& .MuiTypography-root': {
    fontSize: "0.875rem",
  }
}

export const HeaderStyle = {
  textAlign: "center",
  background: (theme: ITheme) => theme.palette.grey[300],
  color: (theme: ITheme) => theme.palette.common.black,
  fontWeight: "bold",
  padding: 1,
  borderBottom: (theme: ITheme) => `solid 2px ${theme.palette.grey["A150"]}`,
}

export const TableHeadStyle = {
  background: (theme: ITheme) => theme.palette.blue[300],
  color: (theme: ITheme) => theme.palette.common.black,
  fontWeight: "bold",
  padding: 1,
  '& .MuiTypography-root': {
    fontWeight: "bold",
    fontSize: "0.875rem",
  }
}

export const ContentStyle = {
  marginBottom: 2,
  fontWeight: "bold",
  fontSize: '0.875rem',
}

export const ButtonStyleAccept = (theme: ITheme) => ({
  textTransform: 'capitalize',
  fontWeight: "bold",
  border: `1px solid ${theme.palette.primary.main}`,
  background: theme.palette.green[200],
  color: theme.palette.common.black,
  minWidth: '70px',
  //width: { xs: 'calc(100% - 16px)', sm: 'auto' },
  maxWidth: '70px',
  m: 1,
  "&:hover": {
    //you want this to be the same as the backgroundColor above
    backgroundColor: theme.palette.green[200],
  }
});

export const ButtonStyleRefuse = (theme: ITheme) => ({
  textTransform: 'capitalize',
  fontWeight: "bold",
  border: `1px solid ${theme.palette.primary.main}`,
  background: theme.palette.red[200],
  color: theme.palette.common.white,
  minWidth: '70px',
  //width: { xs: 'calc(100% - 16px)', sm: 'auto' },
  maxWidth: '70px',
  m: 1,
  "&:hover": {
    //you want this to be the same as the backgroundColor above
    backgroundColor: theme.palette.red[200],
  }
});

export const ButtonStyleCancel = (theme: ITheme) => ({
  textTransform: 'capitalize',
  fontWeight: "bold",
  border: `1px solid ${theme.palette.primary.main}`,
  background: theme.palette.common.white,
  color: theme.palette.blue[400],
  minWidth: '70px',
  //width: { xs: 'calc(100% - 16px)', sm: 'auto' },
  maxWidth: '70px',
  m: 1,
  "&:hover": {
    //you want this to be the same as the backgroundColor above
    backgroundColor: theme.palette.common.white,
  }
});

export const ButtonWrapperStyle = {
  display: 'flex',
  justifyContent: { xs: 'normal', sm: 'normal' },
  pr: { xs: 0, sm: 2 },
  pl: { xs: 0, sm: 2 }
}

export const BoxButtonsWrappingStyle = {
  background: (theme: ITheme) => theme.palette.blue[300],
  color: theme.palette.common.black,
  padding: 1
}

export const OrderInfoTitleStyle = {
  width: "30%",
  pt: 1,
  pb: 1
}

export const OrderInfoContentStyle = {
  width: 70,
  pt: 1,
  pb: 1,
  fontWeight: 700
}

export const OrderInstructionsStyle = {
  mt: 2,
  p: 2,
  pt: 0,
  fontWeight: 700
}

export const TableCellJobStyle = {
  width: "25%",
  pt: 1,
  pb: 1
}

export const TableCellEmpStyle = {
  width: "35%",
  pt: 1,
  pb: 1
}

export const TableCellRegNStyle = {
  pt: 1,
  pb: 1
}